{
  "limits": {
    "overlay": {
      "title": {
        "customColoursOnModels": "Benutzerdefinierte Farben auf Modellen"
      },
      "content": {
        "text1": {
          "customColoursOnModels": "Sie haben derzeit keinen Zugriff darauf, Ihren 3D-Modellen benutzerdefinierte Farben hinzuzufügen. Führen Sie ein Upgrade durch, um gemeinsam mit anderen Teammitgliedern an Plänen zu arbeiten.",
          "customSharedPlanExpiryDuration": "Führen Sie ein Upgrade durch, um benutzerdefinierte Ablaufzeiten für geteilte Links festzulegen."
        }
      }
    }
  }
}